module.exports = __webpack_public_path__ + "bca5f56b6c246e0b2231834c3557bfab.jpg";